import { createFileRoute } from '@tanstack/react-router'
import { FolderUpIcon } from 'lucide-react'

export const Route = createFileRoute('/_auth/_modules/_app/my-uploads')({
  staticData: {
    title: 'route.uploads',
    crumb: 'route.uploads',
    permissions: ['upload_myUpload_view'],
    icon: FolderUpIcon,
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
